import * as types from "./mutation_types";
import Loading from 'quasar/src/plugins/Loading.js';;
import {router} from "@/main";

const getForm = ({ commit,dispatch }, {form = "contact"}) => {
  commit(types.TOGGLE_LOADING);
    Loading.show({group: 'formLoad'})
    let url = "/forms/app/" + form;

    //if (process.env.NODE_ENV === 'development') {
    if(window.location.href.indexOf("localhost") >= 0) {
      url = "http://localhost:9001/app_dev.php" + url;
    }
   //url = "https://bridgeloans.wmmortgageware.com/forms/app/inquire";
   //url = "https://demo.wmmortgageware.com/forms/app/prequalify"
  //url = "https://www.novahomeloans.com/forms/app/purchase";
    fetch(url, {
      //credentials: 'include'
    })
    .then((response) => response.json())
    .then((data) => {

      if(data.force_login === true) {
        commit(types.TOGGLE_LOADING);
        router.push('/signup');
      } else {
        const domain = data.domain;
        const domainJustHost = domain.replace('https://', '').replace('www.', '').replace('/', '');
        const windowDomain = window.location.hostname.replace('www.', '').replace('https://', '');
        if (domainJustHost === windowDomain) {
          data.domain = 'https://' + window.location.hostname
        }

        commit(types.SET_FORM, data);
        commit(types.TOGGLE_LOADING);
      }
      Loading.hide('formLoad');
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ERROR, e.message);
      Loading.hide('formLoad');
      dispatch('alert/error', e.message, { root: true });

    });
};


export const  authenticateUser = ({ commit }, user) => {
  commit(types.SET_USER, user);
};

export const  assignSite = ({ commit }, site) => {
  commit(types.SET_SITE_SETTINGS, site);
};

export const  prefillUserM1 = ({ state, dispatch }, user) => {
  if((!user.first_name && !user.last_name) || !state.form) {
    return;
  }
  var form = state.form;
  var type_first_name = "borrower.first_name";
  var type_last_name = "borrower.last_name";
  var type_email = "borrower.email";
  for(let key in form.screens) {
    for (let keyF in form.screens[key].fields) {
      const field = form.screens[key].fields[keyF];
      if(type_first_name === field.type && user.first_name) {
          dispatch('values/list/updateFieldValue', {fieldSettings: field, fieldValue: user.first_name},{ root: true });
      }
      if(type_last_name === field.type && user.last_name) {
          dispatch('values/list/updateFieldValue', {fieldSettings: field, fieldValue: user.last_name},{ root: true });
      }
      if(type_email === field.type && user.email) {
        dispatch('values/list/updateFieldValue', {fieldSettings: field, fieldValue: user.email},{ root: true });
      }
    }
  }
};

export const  logoutUser = ({ commit }) => {
  commit(types.SET_USER, {
    first_name: '',
    last_name: '',
    authenticated: false,
    email: false
  });
};


export default getForm;
